module.exports = __webpack_public_path__ + "static/media/quincy.9895d0c5.png";